import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx } from "react/jsx-runtime";
var ConfirmationModal = function ConfirmationModal(_ref) {
  var editMode = _ref.editMode,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: editMode ? t('actions_quit_editing_playlist') : t('actions_quit_creating_playlist'),
    body: editMode ? t('modal_confirm_quit_edit_without_save') : t('modal_confirm_quit_creation_without_save'),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel
    }, {
      label: t('actions_confirm'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onCancel
  });
};
export default ConfirmationModal;